/*
    Сообщение об использовании куков
*/

import { Marquee } from './Marquee';


class Disclaimer {
    constructor() {
        this.$container = $('.js-disclaimer');

        this.checkHistory();
        // localStorage.clear(); // debug для IE и мобильных устройств :P
    }

    bindAgree() {
        this.$container.find('.js-disclaimer-agree').on('click', () => {
            window.localStorage.setItem('cookieAgree', true);
            // document.cookie = "cookieAgree=true";
            this.$container.hide();
        });
    }

    checkHistory() {
        if (window.localStorage.cookieAgree) {
            this.$container.hide();
        } else {
            this.initMarquee();
            this.bindAgree();
        }
    }

    initMarquee() {
        // new Marquee(this.$container.find('.js-disclaimer-marquee'));
    }
}

new Disclaimer();

// подключили сторонний скрипт для непрерывной бегущей строки
let textLine = $('.js-disclaimer-marquee').find($('.js-marquee-inner'));
let len = textLine.data('text').length;
let coef = 0.8; // коэффициент ускорения
textLine.marquee({
    duration: len * coef * 1000,
    gap: 10,
    duplicated: true,
    startVisible: true
});



// WEBPACK FOOTER //
// ./_src/js/modules/Disclaimer.js